/* @ngInject */

export default (ticketsService, TICKET) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function TicketDataList(idFilter, orderBy, coerceTo, isDescending, decache) {
    this.isReady = false;
    this.loadedPages = {};
    this.numItems = 0;
    this.PAGE_SIZE = 50;
    this.idFilter = idFilter || null;
    this.orderBy = orderBy || 'timeStamp';
    this.coerceTo = coerceTo || 'string';
    this.isDescending = isDescending || false;
    this.decache = decache;
    this.fetchNumItems_();
  }

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  TicketDataList.prototype.getLength = function () {
    return this.numItems;
  };

  TicketDataList.prototype.getItemAtIndex = function (index) {
    const self = this;
    const pageNumber = Math.floor(index / self.PAGE_SIZE);
    const page = self.loadedPages[pageNumber];
    if (page) {
      return page[index % self.PAGE_SIZE];
    }
    if (page !== null) {
      self.fetchPage_(pageNumber);
    }
  };

  TicketDataList.prototype.fetchPage_ = function (pageNumber) {
    const self = this;
    self.loadedPages[pageNumber] = null;
    ticketsService
      .getByEnterprise({
        decache: self.decache,
        idFilter: self.idFilter,
        orderBy: self.orderBy,
        coerceTo: self.coerceTo,
        isDescending: self.isDescending,
        limit: self.PAGE_SIZE,
        offset: pageNumber * self.PAGE_SIZE,
        fields: TICKET.FIELDS.LIST,
        isActive: true
      })
      .then((tickets) => {
        self.loadedPages[pageNumber] = [].concat(tickets);
        self.isReady = true;
      });
  };

  TicketDataList.prototype.fetchNumItems_ = function () {
    const self = this;
    ticketsService
      .getByEnterprise({ idFilter: self.idFilter, isActive: true, isCount: true })
      .then((totalCount) => {
        self.numItems = _.isArray(totalCount) ? _.first(totalCount) : totalCount;
      });
  };

  return TicketDataList;
};
